<template>
  <span>
    <base-button
      size="sm"
      type="warning"
      style="white-space: normal;margin: 2px"
      v-on:click="logout()"
      >{{ $t("logout") }}</base-button
    >
  </span>
</template>

<script>
import Vue from "vue";

export default {
  props: ["goto"],
  methods: {
    logout() {
      this.$store.dispatch("logout");

      if (!this.goto && this.$router.currentRoute.path !== "/") {
        this.$router.push("/");
      } else {
        this.$router.push(this.goto);
      }
    },
  },
};
</script>

<i18n>
{
  "en": {
    "logout": "Logout"
  },
  "fi": {
    "logout": "Kirjaudu ulos"
  },
  "sv": {
    "logout": "Logga ut"
  },
 "de": {
        "logout": "Ausloggen"
  },
  "ko": {
    "logout": "로그아웃"
  }
}
</i18n>
